import React, { useState, useEffect } from 'react'
import { Grid, Container, Box, Button, TextField, FormControl, InputLabel, Select, MenuItem, Typography, Alert, CircularProgress } from '@mui/material'
import { getDefaults, postHowDoISay, saveDefaults } from './util'
import { type GetDefaultsResponse } from './model'
import queryString from 'query-string'

const SettingsForm: React.FC = () => {
    const [loading, setLoading] = useState(true)
    const [loadingResults, setLoadingResults] = useState(false)
    const [errorMessage, setErrorMessage] = useState('') // add error state
  const [hasError, setHasError] = useState(false) // add error state
  const [hasSoftError, setSoftError] = useState(false) // add error state
  const [successMessage, setSuccessMessage] = useState('') // add success state
  const [language, setLanguage] = useState('') // add success state
  const [question, setQuestion] = useState('')
    const [results, setResults] = useState('')
    const [sendDisabled, setSendDisabled] = useState(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setQuestion(event.target.value)
  }

  useEffect(() => {
    const parsedQuery = queryString.parse(window.location.hash)
    const parsedLanguage = parsedQuery['/how-do-you-say?lang']
    if (Array.isArray(parsedLanguage) || parsedLanguage === undefined || parsedLanguage == null) {
      setHasError(true)
      setErrorMessage('Invalid language provided.')
      setLoading(false)
      return
    } else {
        setLanguage(parsedLanguage)
        setLoading(false)
    }
  }, [])

  if (loading) {
    return <div>
        <CircularProgress />
        Loading...
        </div> // render loading message while defaults are being loaded
  }
  if (hasError) {
    return <Alert severity="error">{errorMessage}</Alert> // render error banner if there's an error
  }

  const defaults = {
    // model: 'gpt-3.5-turbo',
    model: 'gpt-4',
    translationMessage: 'N/A',
    //systemMessage: 'You are a system that explains how to perform the input, or describe the input in Mexican Spanish. Just mention the answer. Do not preface your answer by prefixing it with a sentence like "how do I say". Do not mention mexican spanish because the user already know this',
    //systemMessagWithSpanihExplanation: "You are tasked with responding to inputs by providing clear and direct explanations or descriptions in Mexican Spanish, including colloquial terms where applicable. While succinct answers are often sufficient, gauge the context to determine when additional detail is necessary for clarity or completeness. Avoid using lead-in phrases like 'how do I say' and do not mention that the response is in Mexican Spanish, as this is already the established context.",
    // systemMessageDeprecated: "You are tasked with interpreting standalone inputs and providing immediate, clear responses in Mexican Spanish. Include colloquial expressions where relevant. Aim for succinctness, yet offer sufficient detail to ensure the answer is understood in isolation. Avoid introductory phrases and do not reference the language explicitly, as the context of Mexican Spanish usage is implicit.",
    systemMessageDefault: "You are tasked with responding to inputs by providing clear and direct phrases in Mexican Spanish. Include colloquial expressions where relevant. When additional detail is necessary for clarity or completeness, please provide these explanations in English. Aim for succinctness but ensure the user can understand the usage and context of the phrases without assuming advanced knowledge of Mexican Spanish. Avoid using lead-in phrases and do not reference the language explicitly, as the usage context is understood.",
    systemMessage: "You are tasked with providing responses in Mexican Spanish that not only answer the input directly but also offer relevant explanations or contextual details in English. These should elucidate the usage, nuances, or variations of the provided phrase, aiding comprehension and learning. While the core response should be in Mexican Spanish, any additional detail for clarity or educational value should be presented in English.",
    grammarCheckFormat: 'N/A',
    firstBotMessage: ''
  }
  const submitForm = () => {
    setSendDisabled(true)

    // check if question is empty
    if (!question.trim()) {
        setResults('Please enter something')
        setSendDisabled(false)
        return
    }
    postHowDoISay(question, defaults).then((response) => {
        setResults(response.messages[0].message)
    }).catch((err) => {
        //setHasError(true)
        setResults('Failed to send message: ' + err);
    }).finally(()=>{
        setSendDisabled(false)
        setLoadingResults(false)
    })
    console.log("HEYEYTEYTEYHEEH")
  }

  const handleSubmit = (event: React.FormEvent): void => {
    event.preventDefault()
    // const newDefaults = {
    //   model,
    //   translationMessage: translationPromptMessage,
    //   systemMessage,
    //   grammarCheckFormat,
    //   firstBotMessage
    // }

    // saveDefaults(newDefaults)
    //   .then(() => {
    //     setSuccessMessage('Defaults saved successfully!') // set success state if saveDefaults succeeds
    //     setSoftError(false)
    //   })
    //   .catch(err => {
    //     setErrorMessage('Failed to save defaults: ' + err) // set error state if saveDefaults fails
    //     setSoftError(true)
    //   })
  }

  
  return (
    <Container>
    {hasSoftError && <Alert severity="error">{errorMessage}</Alert>}
    <Grid container justifyContent="center" spacing={3}>
      <Grid item>
        <Typography variant="h2">How do I({language})</Typography>
        <form onSubmit={handleSubmit}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs>
              <TextField 
                label="how do i" 
                variant="outlined" 
                value={question} 
                onChange={handleChange}
                name="how-do-i"
                fullWidth
              />
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" type="submit" disabled={sendDisabled} onClick={submitForm}>
                Send
              </Button>
            </Grid>
          </Grid>
          <Typography variant="h6">
    {loadingResults && <CircularProgress />}
    {!loadingResults && results.split('\n').map((line, index) => (
        line.trim() !== '' && <Typography key={index} variant="body1" gutterBottom>
            {line}
        </Typography>
    ))}
</Typography>

        </form>
      </Grid>
          <Grid item></Grid>
    </Grid>
  </Container>
  )
}

export default SettingsForm
